import { createSlice } from "@reduxjs/toolkit";
import {
  SliderData,
  SliderInitialStatus,
} from "../../../../../types/webCms/homePage/slider";
import { getAllSliderAsync, updateSLiderDataAsync } from "./sliderApi";

const initialState: SliderInitialStatus<SliderData> = {
  loading: false,
  manageLoading: false,
  sliderDataList: [],
  countSliderData: 0,
};

const sliderSlice = createSlice({
  name: "admin-slider",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllSliderAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllSliderAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.sliderDataList = action.payload.data;
        state.countSliderData = action.payload.length;
      })
      .addCase(getAllSliderAsync.rejected, (state) => {
        state.loading = false;
        state.sliderDataList = [];
        state.countSliderData = 0;
      });

    // update
    builder
      .addCase(updateSLiderDataAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateSLiderDataAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateSLiderDataAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default sliderSlice;
